export type ProductNutrition = {
  serving: string;
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
};

export type ProductDetails = {
  description: string;
  ingredients: string;
  allergens: string[];
  nutrition: ProductNutrition;
};

export const productDetails: Record<
  string,
  ProductDetails
> = {
  cappuccino: {
    description:
      "Классический эспрессо с горячим молоком и плотной молочной пеной.",
    ingredients:
      "Эспрессо, молоко.",
    allergens: ["Молоко"],
    nutrition: {
      serving: "300 мл",
      calories: 145,
      protein: 7,
      fat: 7,
      carbs: 13,
    },
  },

  latte: {
    description:
      "Мягкий молочный кофе на основе эспрессо с большим количеством горячего молока и нежной пеной.",
    ingredients:
      "Эспрессо, молоко.",
    allergens: ["Молоко"],
    nutrition: {
      serving: "300 мл",
      calories: 170,
      protein: 8,
      fat: 8,
      carbs: 16,
    },
  },

  americano: {
    description:
      "Насыщенный эспрессо, дополненный горячей водой. Чистый кофейный вкус без молока.",
    ingredients:
      "Эспрессо, питьевая вода.",
    allergens: [],
    nutrition: {
      serving: "300 мл",
      calories: 10,
      protein: 0.5,
      fat: 0.2,
      carbs: 1.5,
    },
  },

  raf: {
    description:
      "Сливочный кофейный напиток на основе эспрессо с мягкой текстурой и ванильными нотами.",
    ingredients:
      "Эспрессо, сливочная молочная основа, ванильный сахар.",
    allergens: ["Молоко"],
    nutrition: {
      serving: "300 мл",
      calories: 260,
      protein: 6,
      fat: 16,
      carbs: 24,
    },
  },

  cocoa: {
    description:
      "Горячий шоколадно-молочный напиток с насыщенным вкусом какао.",
    ingredients:
      "Молоко, какао-порошок, сахар.",
    allergens: ["Молоко"],
    nutrition: {
      serving: "300 мл",
      calories: 210,
      protein: 8,
      fat: 8,
      carbs: 27,
    },
  },

  tea: {
    description:
      "Горячий чай. В зависимости от выбранного вкуса может дополняться ягодами, фруктами или сиропом.",
    ingredients:
      "Чай, питьевая вода. Дополнительные ингредиенты зависят от выбранного вкуса.",
    allergens: [],
    nutrition: {
      serving: "400 мл",
      calories: 35,
      protein: 0.2,
      fat: 0.1,
      carbs: 8,
    },
  },

  bumble: {
    description:
      "Освежающий холодный кофе с эспрессо и апельсиновым соком. Яркое сочетание кофе и цитруса.",
    ingredients:
      "Эспрессо, апельсиновый сок, лёд.",
    allergens: [],
    nutrition: {
      serving: "400 мл",
      calories: 155,
      protein: 2,
      fat: 0.5,
      carbs: 35,
    },
  },

  "iced-latte": {
    description:
      "Холодный молочный кофе на основе эспрессо со льдом.",
    ingredients:
      "Эспрессо, молоко, лёд.",
    allergens: ["Молоко"],
    nutrition: {
      serving: "400 мл",
      calories: 165,
      protein: 8,
      fat: 7,
      carbs: 17,
    },
  },

  lemonade: {
    description:
      "Освежающий холодный лимонад с фруктово-ягодной основой и льдом.",
    ingredients:
      "Газированная вода, фруктово-ягодная основа, сироп, лёд.",
    allergens: [],
    nutrition: {
      serving: "400 мл",
      calories: 150,
      protein: 0.2,
      fat: 0.1,
      carbs: 37,
    },
  },

  smoothie: {
    description:
      "Густой холодный фруктово-ягодный напиток с насыщенным вкусом.",
    ingredients:
      "Фруктово-ягодное пюре, сок или молочная основа, лёд.",
    allergens: [
      "Возможны молочные ингредиенты",
    ],
    nutrition: {
      serving: "400 мл",
      calories: 220,
      protein: 3,
      fat: 2,
      carbs: 48,
    },
  },

  "juice-bowl": {
    description:
      "Яркий холодный фруктовый напиток на основе сока с насыщенным вкусом.",
    ingredients:
      "Фруктовый сок, фруктово-ягодная основа, сироп, лёд.",
    allergens: [],
    nutrition: {
      serving: "400 мл",
      calories: 210,
      protein: 1,
      fat: 0.5,
      carbs: 50,
    },
  },

  hotdog: {
    description:
      "Горячая сосиска в мягкой булочке с маринованным огурцом, луком и соусами.",
    ingredients:
      "Пшеничная булочка, сосиска, маринованный огурец, лук, кетчуп, горчица, соус.",
    allergens: [
      "Глютен",
      "Горчица",
      "Возможны молоко и соя",
    ],
    nutrition: {
      serving: "1 порция",
      calories: 410,
      protein: 15,
      fat: 23,
      carbs: 36,
    },
  },

  frenchdog: {
    description:
      "Сосиска в закрытой французской булочке с кетчупом, горчицей и соусом.",
    ingredients:
      "Французская пшеничная булочка, сосиска, кетчуп, горчица, соус.",
    allergens: [
      "Глютен",
      "Горчица",
      "Возможны молоко и соя",
    ],
    nutrition: {
      serving: "1 порция",
      calories: 395,
      protein: 14,
      fat: 21,
      carbs: 37,
    },
  },

  corndog: {
    description:
      "Сосиска в хрустящем кукурузном тесте, обжаренная до золотистой корочки.",
    ingredients:
      "Сосиска, кукурузно-пшеничное тесто, растительное масло.",
    allergens: [
      "Глютен",
      "Яйцо",
      "Возможны молоко и соя",
    ],
    nutrition: {
      serving: "1 шт.",
      calories: 330,
      protein: 11,
      fat: 18,
      carbs: 32,
    },
  },

  fries: {
    description:
      "Хрустящий картофель фри с золотистой корочкой.",
    ingredients:
      "Картофель, растительное масло, соль.",
    allergens: [],
    nutrition: {
      serving: "1 порция",
      calories: 310,
      protein: 4,
      fat: 15,
      carbs: 40,
    },
  },

  nuggets: {
    description:
      "Кусочки куриного мяса в хрустящей золотистой панировке.",
    ingredients:
      "Куриное мясо, панировка, растительное масло.",
    allergens: [
      "Глютен",
      "Возможны молоко, яйцо и соя",
    ],
    nutrition: {
      serving: "6 шт.",
      calories: 285,
      protein: 16,
      fat: 17,
      carbs: 17,
    },
  },

  "cheese-sticks": {
    description:
      "Горячие сырные палочки в хрустящей панировке с расплавленным сыром внутри.",
    ingredients:
      "Сыр, панировка, растительное масло.",
    allergens: [
      "Молоко",
      "Глютен",
      "Возможны яйцо и соя",
    ],
    nutrition: {
      serving: "1 порция",
      calories: 360,
      protein: 17,
      fat: 22,
      carbs: 25,
    },
  },

  shrimp: {
    description:
      "Креветки в хрустящей панировке или кляре, обжаренные до золотистой корочки.",
    ingredients:
      "Креветки, панировка или кляр, растительное масло.",
    allergens: [
      "Ракообразные",
      "Глютен",
      "Возможны яйцо и молоко",
    ],
    nutrition: {
      serving: "1 порция",
      calories: 290,
      protein: 18,
      fat: 15,
      carbs: 21,
    },
  },
};
